import React from 'react';
import PropTypes from 'prop-types';

const CustomSelect = ({
	id,
	label,
	inAsset,
	value,
	type,
	optionList,
	disabled,
	required,
	isTouched,
	errors,
	onChange
}) => (
	<div className="form-group">
		<label>
			{label}
			{required ? <span>*</span> : null}
		</label>
		<select className={'form-control ' + (isTouched[id] && errors[id] ? 'field-error' : '')}
			id={id}
			disabled={disabled}
			value={value}
			onChange={e => onChange(e, type, inAsset)}>
			<option value="-1" key={-1}>Select</option>
			{optionList.map((o, i) => {
				return <option key={i + '__' + o.value} value={o.value}>{o.display_name}</option>;
			})}
		</select>
		{
			isTouched[id] && errors[id] ?
				<div className="form-control-errors-wrapper">
					{ errors[id] === 'required' && <p>{label} is required.</p> }
				</div> :
				null
		}
	</div>
);

CustomSelect.propTypes = {
	id: PropTypes.string,
	label: PropTypes.string,
	inAsset: PropTypes.bool,
	value: PropTypes.string,
	type: PropTypes.string,
	optionList: PropTypes.array,
	disabled: PropTypes.bool,
	required: PropTypes.bool,
	isTouched: PropTypes.object,
	errors: PropTypes.object,
	onChange: PropTypes.func
};

export default CustomSelect;